module.exports = __webpack_public_path__ + "img/更多开发类.312b7b21.png";